/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

interface PauseProps {
  title?: string;
}

/**
 * This is the Pause component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Pause({ title = 'Pause' }: PauseProps) {
  return (
    <span className="svg svg-square svg-pause">
      <span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{title}</title>
          <path d="M6 19H10V5H6V19ZM14 5V19H18V5H14Z" fill="black" />
        </svg>
      </span>
    </span>
  );
}

export default Pause;
